<template>
  <div>
    <NavbarTwo />
    <div class="static-hero">
      <div class="container mw-1356">
        <span class="top-title">LEGAL</span>
        <h1>Return &amp; Refund Policy</h1>
        <p>Your options if the service isn't right for you</p>
      </div>
    </div>
    <div class="static-body bg-gondola">
      <div class="container mw-1356" style="max-width:860px">
        <div class="pp-section">
          <p>
            This Refund Policy applies to subscriptions purchased from {{ c.tradingName }}
            ({{ c.legalName }}). Because we sell digital streaming subscriptions, the following
            terms set out when a refund is available.
          </p>
        </div>

        <div class="pp-section">
          <h2>1. {{ c.refund.windowDays }}-Day Refund Window</h2>
          <p>
            If you experience a technical problem that prevents you from using the service and our
            support team is unable to resolve it, you may request a full refund within
            <strong>{{ c.refund.windowDays }} days</strong> of your purchase.
          </p>
        </div>

        <div class="pp-section">
          <h2>2. How to Request a Refund</h2>
          <ul>
            <li>Contact us at <a :href="'mailto:' + c.support.email">{{ c.support.email }}</a> with your account email and order reference.</li>
            <li>Describe the issue so our team can attempt a fix first — most issues are resolved quickly.</li>
            <li>If we cannot resolve it within the window, we will refund your payment to the original card.</li>
          </ul>
        </div>

        <div class="pp-section">
          <h2>3. Processing Time</h2>
          <p>
            Approved refunds are issued to your original payment method via our payment facilitator,
            {{ c.payments.facilitator.name }}. Refunds are processed in
            <strong>{{ c.payments.currency }}</strong> and typically appear within 5–10 business
            days, depending on your bank.
          </p>
        </div>

        <div class="pp-section">
          <h2>4. Exclusions</h2>
          <ul>
            <li>Requests made after the {{ c.refund.windowDays }}-day window.</li>
            <li>Accounts suspended or terminated for breach of our <RouterLink to="/terms-conditions">Terms &amp; Conditions</RouterLink> (e.g. sharing, resale, fraud).</li>
            <li>Issues caused by your own internet connection, hardware or third-party apps where the service itself is functioning.</li>
            <li>Change of mind after the service has been used substantially during the window.</li>
          </ul>
        </div>

        <div class="pp-section">
          <h2>5. Chargebacks</h2>
          <p>
            Please contact us before initiating a card chargeback — we will always try to make it
            right. Fraudulent chargebacks may result in account termination.
          </p>
        </div>

        <div class="pp-section">
          <h2>6. Contact</h2>
          <p>
            {{ c.legalName }} · {{ address }}<br />
            <span v-if="c.support.email">Email: <a :href="'mailto:' + c.support.email">{{ c.support.email }}</a></span>
            <span v-if="c.support.phone"> · Phone: {{ c.support.phone }}</span>
          </p>
        </div>
      </div>
    </div>
    <CopyRight />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavbarTwo from "@/components/Layouts/NavbarTwo.vue";
import CopyRight from "@/components/Layouts/CopyRight.vue";
import { company, establishmentLine } from "@/config/company";

export default defineComponent({
  name: "RefundPolicyPage",
  components: { NavbarTwo, CopyRight },
  setup() {
    return { c: company, address: establishmentLine() };
  },
});
</script>

<style scoped>
.static-hero {
  background: linear-gradient(135deg, #1a0a0b 0%, #2d1214 100%);
  padding: 120px 0 60px;
  text-align: center;
}
.static-hero .top-title {
  display: inline-block;
  background: rgba(201, 14, 14, 0.15);
  color: #e84749;
  border: 1px solid rgba(201, 14, 14, 0.3);
  padding: 0.3rem 1rem;
  border-radius: 20px;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 1rem;
}
.static-hero h1 {
  color: #fff;
  font-size: clamp(2rem, 5vw, 3.2rem);
  font-weight: 900;
  margin-bottom: 0.75rem;
}
.static-hero p {
  color: #c0c0c0;
  font-size: 1.1rem;
}
.static-body {
  padding: 80px 0 100px;
}
.bg-gondola {
  background: #120a0b;
}
.pp-section {
  margin-bottom: 2.5rem;
}
.pp-section h2 {
  color: #fff;
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #2d1214;
}
.pp-section p,
.pp-section li {
  color: #c0c0c0;
  line-height: 1.8;
  font-size: 0.95rem;
}
.pp-section ul {
  padding-left: 1.5rem;
}
.pp-section ul li {
  margin-bottom: 0.4rem;
}
.pp-section a {
  color: #e84749;
  text-decoration: none;
}
.pp-section a:hover {
  text-decoration: underline;
}
</style>
